<div class="credit-withdraw-content-container" *ngIf="isOpen">
  <!-- Checked Customer 2-->
  <ng-container
    *ngIf="
      this._UserHelper.withdrawList && this._UserHelper.withdrawList.length > 0 && (this._DataHelper.selectedWallet.BranchType == 1 ? this._UserHelper.userInsicStatus === 2 : true)
    ">
    <div class="credit-input-container">
      <div class="withdraw-text-container">
        {{ 'b3000_Withdraw_text_3' | t }}
      </div>
      <div class="withdraw-text-container">
        {{ 'b3000_Withdraw_text_4' | t }}
      </div>
      <inputb3
        [extraClass]="'amountInput'"
        fPlaceholder="{{ 'Amount' | t }}"
        fInputType="number"
        fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
        [(ngModel)]="amount"></inputb3>
    </div>
    <div class="payment-method-container">
      <div class="payment-method-row" *ngFor="let withdrawItem of this._UserHelper.withdrawList">
        <div class="payment-left-side">
          <input type="radio" name="withdraw-method" id="withdraw_{{ withdrawItem.DepositTypeId }}" value="{{ withdrawItem.DepositTypeId }}" [(ngModel)]="WithdrawpaymentType" />
          <div class="trustly-icon">
            <!-- Yeni Dosya yollarınıu ver src yi değiştir eski yapıda kullanabildiklerini kullan kullanamadıklarını iste -->
            <image-loader-utils
              [url]="withdrawItem.Description"
              [imageFormat]="withdrawItem.DepositTypeId == 85 ? 'png' : 'svg'"
              extraClasses="icon payment-methods-icon"
              altText="deposit_{{ withdrawItem.PaymentType }}"></image-loader-utils>
          </div>
        </div>
        <div class="payment-right-side">{{ 'b3000_Min' | t }}. {{ withdrawItem.MinValue }}{{ _UserHelper.customerUser?.Symbol }}</div>
      </div>
    </div>
    <div class="withdraw-limit-container">
      <div>
        <div class="row-initial">
          {{ 'b3000_Withdraw_Text' | t }}
        </div>
        <div class="row-initial bold">
          {{ this._UserHelper.withdrawList[0]?.DescriptionLong }}
          {{ this._UserHelper.customerUser.Symbol }}
        </div>
        <div class="row-initial">
          {{ 'b3000_Withdraw_Text2' | t }}
        </div>
      </div>
      <div class="go-setlimit-container" (click)="OpenAccountMobile(6)">
        {{ 'b3000_Withdraw_Text3' | t }}
      </div>
    </div>
    <div class="confirm-button-container">
      <div class="alert-message" *ngIf="this._UserHelper.withdrawList[0]?.RiskLevelId == -1">
        {{ 'b3000_WithdrawBonusText' | t }}
      </div>
      <div class="alert-message" *ngIf="alertMessage">
        {{ alertMessageDesc }}
      </div>
      <ng-template #noAmount>
        <div class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </ng-template>
      <div *ngIf="amount >= 10 && WithdrawpaymentType; else noAmount" class="btn colored register-button save-changes-button confirm-button" (click)="confirmButton()">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>

    <div class="payment-sub-text">
      {{ 'b3000_Withdraw_text_2' | t }}
    </div>
  </ng-container>
  <!-- No-Checked 0 and Pre Checked 1  -->

  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 0 || this._UserHelper.userInsicStatus === -2)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_1' | t }}
          <span class="underline-text" (click)="OpenAccountMobile(8)">
            {{ 'b3000_Deposit_Text_2' | t }}
          </span>
        </p>
      </div>
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_3' | t }}
        </p>

        <div class="btn colored register-button save-changes-button confirm-button green" (click)="OpenAccountMobile(8)">
          <div class="btn-text" style="color: #fff !important">
            {{ 'b3000_Deposit_Text_4' | t }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Bloked Customer 4 and -1 -->
  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 4 || this._UserHelper.userInsicStatus === -1)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext" style="font-size: 16px; font-weight: 600">
          {{ 'b3000_Withdraw_Text_1' | t }}

          <a [href]="'contactUrl' | getEnv" style="text-decoration: underline; color: #000; font-size: 16px; font-weight: 600">
            {{ 'b3000_Withdraw_Text_2' | t }}
          </a>
        </p>
      </div>
    </div>
  </ng-container>
</div>
